// Side-effect barrel for the legacy mailCampaign subtree (WEB-8483). root.jsx creates the
// ReactTemplates.mailCampaign namespace; the rest populate its keys at module eval. Loaded once
// by ReactTemplatesShim at the React entry (root first).
import './mailCampaign/root';
import './mailCampaign/sidebar';
import './mailCampaign/components/column-chart';
import './mailCampaign/components/column-list';
import './mailCampaign/components/column-row';
import './mailCampaign/components/recipientFilters';
import './mailCampaign/components/table';
import './mailCampaign/components/tableSearch';
import './mailCampaign/components/timeline';
import './mailCampaign/pages/dashboard';
import './mailCampaign/pages/recipients';
import './mailCampaign/pages/submits';
import './mailCampaign/pages/visits';
